document.addEventListener('DOMContentLoaded', function () {
  const rolexItems = document.querySelectorAll('.rolex-appointment-item');
  const rolexForms = document.querySelectorAll('.rolex-appointment-form');
  const rolexHeader = document.querySelector('.rolex-appointment_header');
  const rolexContent = document.querySelector('.rolex-appointment_content');
  const rolexBlocksWrapper = document.querySelector('.rolex-appointment-blocks');

  function rolexShowMainView() {
    [rolexHeader, rolexContent].forEach(el => {
      el?.classList.remove('form-group-hidden');
      el?.classList.add('form-group-block');
    });

    rolexBlocksWrapper?.classList.remove('form-group-hidden');
    rolexBlocksWrapper?.classList.add('form-group-block');

    rolexForms.forEach(form => {
      form.classList.remove('form-group-block');
      form.classList.add('form-group-hidden');
    });
  }

  function rolexShowFormById(id) {
    rolexForms.forEach(form => {
      form.classList.remove('form-group-block');
      form.classList.add('form-group-hidden');
    });

    const selectedForm = document.querySelector(`.rolex-appointment-form-${id}`);
    if (selectedForm) {
      selectedForm.classList.remove('form-group-hidden');
      selectedForm.classList.add('form-group-block');
    }

    [rolexHeader, rolexContent, rolexBlocksWrapper].forEach(el => {
      el?.classList.remove('form-group-block');
      el?.classList.add('form-group-hidden');
    });
  }

  // Back to block
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('.backtoblock')) {
      rolexShowMainView();
    }
  });

  // Click on appointment items
  rolexItems.forEach(item => {
    const btn = item.querySelector('button');
    btn?.addEventListener('click', () => {
      const id = item.getAttribute('data-id');

      const textBlock = item.querySelector('.rolex-appointment-block-text');
      document.querySelectorAll(".rolex-appointment-block-text").forEach(i => i.classList.remove("active"));
      textBlock?.classList.add("active");

      // Purpose text update

      if (id) rolexShowFormById(id);
    });
  });

  // Init view
  rolexShowMainView();
});
document.addEventListener("DOMContentLoaded", function () {
  // The HTML you want in the label
  const LABEL_HTML = `I have read and accepted the
    <a href="/pages/terms" target="_blank">terms and conditions</a>
    and
    <a href="/pages/privacy-policy" target="_blank">privacy policy</a>`;

  // Selector for the correct checkbox label
  const SELECTOR =
    '.rpo-form_checkbox[data-element-id="checkbox-1"] .checkbox-wrapper > label.checkbox-label.globo-option';

  function applyOnce(root = document) {
    const el = root.querySelector(SELECTOR);
    if (!el || el.dataset.patched === '1') return;

    el.innerHTML = LABEL_HTML;
    el.setAttribute(
      "aria-label",
      "I have read and accepted the terms and conditions and privacy policy"
    );
    el.dataset.patched = '1';

    // Prevent link clicks from toggling checkbox
    el.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', e => e.stopPropagation());
    });
  }

  // Run on first load
  applyOnce();

  // Watch for DOM changes (multi-step re-render)
  const obs = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
            applyOnce(node);
          }
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  // Shopify section reload handling
  document.addEventListener("shopify:section:load", () => applyOnce());
  document.addEventListener("shopify:section:select", () => applyOnce());
});

document.addEventListener("DOMContentLoaded", function () {
  // Delay execution by 2 seconds (2000 milliseconds)
  setTimeout(function () {
    const phoneCode=[{"label":"+355","value":"+355"},{"label":"+213","value":"+213"},{"label":"+1684","value":"+1684"},{"label":"+376","value":"+376"},{"label":"+244","value":"+244"},{"label":"+1264","value":"+1264"},{"label":"+1268","value":"+1268"},{"label":"+54","value":"+54"},{"label":"+374","value":"+374"},{"label":"+297","value":"+297"},{"label":"+61","value":"+61"},{"label":"+43","value":"+43"},{"label":"+994","value":"+994"},{"label":"+1242","value":"+1242"},{"label":"+973","value":"+973"},{"label":"+880","value":"+880"},{"label":"+1246","value":"+1246"},{"label":"+375","value":"+375"},{"label":"+32","value":"+32"},{"label":"+501","value":"+501"},{"label":"+229","value":"+229"},{"label":"+1441","value":"+1441"},{"label":"+975","value":"+975"},{"label":"+591","value":"+591"},{"label":"+387","value":"+387"},{"label":"+267","value":"+267"},{"label":"+55","value":"+55"},{"label":"+246","value":"+246"},{"label":"+1284","value":"+1284"},{"label":"+673","value":"+673"},{"label":"+359","value":"+359"},{"label":"+226","value":"+226"},{"label":"+257","value":"+257"},{"label":"+855","value":"+855"},{"label":"+237","value":"+237"},{"label":"+238","value":"+238"},{"label":"+599","value":"+599"},{"label":"+1345","value":"+1345"},{"label":"+236","value":"+236"},{"label":"+235","value":"+235"},{"label":"+56","value":"+56"},{"label":"+86","value":"+86"},{"label":"+61","value":"+61"},{"label":"+57","value":"+57"},{"label":"+269","value":"+269"},{"label":"+243","value":"+243"},{"label":"+242","value":"+242"},{"label":"+682","value":"+682"},{"label":"+506","value":"+506"},{"label":"+225","value":"+225"},{"label":"+385","value":"+385"},{"label":"+53","value":"+53"},{"label":"+357","value":"+357"},{"label":"+420","value":"+420"},{"label":"+45","value":"+45"},{"label":"+253","value":"+253"},{"label":"+1767","value":"+1767"},{"label":"+1","value":"+1"},{"label":"+593","value":"+593"},{"label":"+20","value":"+20"},{"label":"+503","value":"+503"},{"label":"+240","value":"+240"},{"label":"+291","value":"+291"},{"label":"+372","value":"+372"},{"label":"+251","value":"+251"},{"label":"+500","value":"+500"},{"label":"+298","value":"+298"},{"label":"+679","value":"+679"},{"label":"+358","value":"+358"},{"label":"+33","value":"+33"},{"label":"+594","value":"+594"},{"label":"+689","value":"+689"},{"label":"+241","value":"+241"},{"label":"+220","value":"+220"},{"label":"+995","value":"+995"},{"label":"+49","value":"+49"},{"label":"+233","value":"+233"},{"label":"+350","value":"+350"},{"label":"+30","value":"+30"},{"label":"+299","value":"+299"},{"label":"+1473","value":"+1473"},{"label":"+590","value":"+590"},{"label":"+1671","value":"+1671"},{"label":"+502","value":"+502"},{"label":"+224","value":"+224"},{"label":"+245","value":"+245"},{"label":"+592","value":"+592"},{"label":"+509","value":"+509"},{"label":"+504","value":"+504"},{"label":"+852","value":"+852"},{"label":"+36","value":"+36"},{"label":"+354","value":"+354"},{"label":"+91","value":"+91"},{"label":"+62","value":"+62"},{"label":"+98","value":"+98"},{"label":"+964","value":"+964"},{"label":"+353","value":"+353"},{"label":"+972","value":"+972"},{"label":"+39","value":"+39"},{"label":"+1876","value":"+1876"},{"label":"+81","value":"+81"},{"label":"+44","value":"+44"},{"label":"+962","value":"+962"},{"label":"+254","value":"+254"},{"label":"+686","value":"+686"},{"label":"+383","value":"+383"},{"label":"+965","value":"+965"},{"label":"+996","value":"+996"},{"label":"+856","value":"+856"},{"label":"+371","value":"+371"},{"label":"+961","value":"+961"},{"label":"+266","value":"+266"},{"label":"+231","value":"+231"},{"label":"+218","value":"+218"},{"label":"+423","value":"+423"},{"label":"+370","value":"+370"},{"label":"+352","value":"+352"},{"label":"+853","value":"+853"},{"label":"+389","value":"+389"},{"label":"+261","value":"+261"},{"label":"+265","value":"+265"},{"label":"+60","value":"+60"},{"label":"+960","value":"+960"},{"label":"+223","value":"+223"},{"label":"+356","value":"+356"},{"label":"+692","value":"+692"},{"label":"+596","value":"+596"},{"label":"+222","value":"+222"},{"label":"+230","value":"+230"},{"label":"+262","value":"+262"},{"label":"+52","value":"+52"},{"label":"+691","value":"+691"},{"label":"+373","value":"+373"},{"label":"+377","value":"+377"},{"label":"+976","value":"+976"},{"label":"+382","value":"+382"},{"label":"+1664","value":"+1664"},{"label":"+212","value":"+212"},{"label":"+258","value":"+258"},{"label":"+95","value":"+95"},{"label":"+264","value":"+264"},{"label":"+674","value":"+674"},{"label":"+977","value":"+977"},{"label":"+31","value":"+31"},{"label":"+687","value":"+687"},{"label":"+64","value":"+64"},{"label":"+505","value":"+505"},{"label":"+227","value":"+227"},{"label":"+234","value":"+234"},{"label":"+683","value":"+683"},{"label":"+672","value":"+672"},{"label":"+850","value":"+850"},{"label":"+1670","value":"+1670"},{"label":"+47","value":"+47"},{"label":"+968","value":"+968"},{"label":"+92","value":"+92"},{"label":"+680","value":"+680"},{"label":"+970","value":"+970"},{"label":"+507","value":"+507"},{"label":"+675","value":"+675"},{"label":"+595","value":"+595"},{"label":"+51","value":"+51"},{"label":"+63","value":"+63"},{"label":"+48","value":"+48"},{"label":"+351","value":"+351"},{"label":"+974","value":"+974"},{"label":"+40","value":"+40"},{"label":"+7","value":"+7"},{"label":"+250","value":"+250"},{"label":"+290","value":"+290"},{"label":"+1869","value":"+1869"},{"label":"+1758","value":"+1758"},{"label":"+508","value":"+508"},{"label":"+1784","value":"+1784"},{"label":"+685","value":"+685"},{"label":"+378","value":"+378"},{"label":"+239","value":"+239"},{"label":"+966","value":"+966"},{"label":"+221","value":"+221"},{"label":"+381","value":"+381"},{"label":"+248","value":"+248"},{"label":"+232","value":"+232"},{"label":"+65","value":"+65"},{"label":"+1721","value":"+1721"},{"label":"+421","value":"+421"},{"label":"+386","value":"+386"},{"label":"+677","value":"+677"},{"label":"+252","value":"+252"},{"label":"+27","value":"+27"},{"label":"+82","value":"+82"},{"label":"+211","value":"+211"},{"label":"+34","value":"+34"},{"label":"+94","value":"+94"},{"label":"+249","value":"+249"},{"label":"+597","value":"+597"},{"label":"+268","value":"+268"},{"label":"+46","value":"+46"},{"label":"+41","value":"+41"},{"label":"+963","value":"+963"},{"label":"+886","value":"+886"},{"label":"+992","value":"+992"},{"label":"+255","value":"+255"},{"label":"+66","value":"+66"},{"label":"+670","value":"+670"},{"label":"+228","value":"+228"},{"label":"+690","value":"+690"},{"label":"+676","value":"+676"},{"label":"+1868","value":"+1868"},{"label":"+216","value":"+216"},{"label":"+90","value":"+90"},{"label":"+993","value":"+993"},{"label":"+1649","value":"+1649"},{"label":"+688","value":"+688"},{"label":"+1340","value":"+1340"},{"label":"+256","value":"+256"},{"label":"+380","value":"+380"},{"label":"+971","value":"+971"},{"label":"+44","value":"+44"},{"label":"+598","value":"+598"},{"label":"+998","value":"+998"},{"label":"+678","value":"+678"},{"label":"+379","value":"+379"},{"label":"+58","value":"+58"},{"label":"+84","value":"+84"},{"label":"+681","value":"+681"},{"label":"+967","value":"+967"},{"label":"+260","value":"+260"},{"label":"+263","value":"+263"}];
    // Select box element
    const select = document.querySelector('select[name="select-2"]');
    if (!select) return; // stop if element not found

    // Clear old options (optional)
    select.innerHTML = "";

    // Iterate over JSON data
    phoneCode.forEach(item => {
      const option = document.createElement("option");
      option.value = item.value;
      option.textContent = item.label;
      select.appendChild(option);
    });

    // Set specific default value
    const specificValue = "+44";
    select.value = specificValue;
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("globo.formbuilder.form.submitted", function (e) {

    var prevBtn = document.querySelector(".gfb__sticky-navigation-previous");
      if (prevBtn) {
          prevBtn.style.display = "none";
      }

    const successElement = document.querySelector(".rolex-thankyou_mssg");
    if (successElement) {
      successElement.style.display = "grid";
      requestAnimationFrame(() => {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const offset = isMobile ? 170 : 300;
        const scrollY = window.pageYOffset || window.scrollY || 0;
        const top = successElement.getBoundingClientRect().top + scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      });
    }

    if (window.location.pathname === "/pages/rolex-book-an-appointment") {
      // Visible form
      const visibleForm = document.querySelector(".rolex-appointment-form.form-group-block") || document;
      const dateField = visibleForm.querySelector('input[name="datetime-1"]');
      const timeField = visibleForm.querySelector('input[name="datetime-2"]');
      const dateValue = dateField?.value || "";
      const timeValue = timeField?.value || "";

      // Format date string (keep Morning/Evening as-is)
      function formatCustomDate(dateValue, timeValue) {
            if (!dateValue || !timeValue) return '';
            var parts = dateValue.split('-');
            var year = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10) - 1;
            var day = parseInt(parts[2], 10);

            var timeParts = timeValue.match(/^(\d{1,2}):(\d{2})\s*([AP]M)$/i);
            if (!timeParts) return '';
            var hour = parseInt(timeParts[1], 10);
            var minute = parseInt(timeParts[2], 10);
            var ampm = timeParts[3].toUpperCase();

            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;

            var dateObj = new Date(year, month, day, hour, minute);
            var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
            var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
            var hour12 = dateObj.getHours() % 12 || 12;
            var minuteStr = dateObj.getMinutes().toString().padStart(2, '0');
            var meridian = dateObj.getHours() < 12 ? 'AM' : 'PM';

            return days[dateObj.getDay()] + " " +
                  dateObj.getDate() + " " +
                  months[dateObj.getMonth()] + " " +
                  dateObj.getFullYear() + " at " +
                  hour12 + ":" + minuteStr + " " + meridian;
          }

      // Update DATE summary
      const prettyDate = formatCustomDate(dateValue, timeValue);
      if (prettyDate) {
        const dateStrong = document.querySelector("p.bespoke_body20.detailed-date strong");
        if (dateStrong) {
          while (dateStrong.nextSibling) dateStrong.parentNode.removeChild(dateStrong.nextSibling);
          dateStrong.after(" " + prettyDate);
        }
      }

      // Update LOCATION summary
      const checkedRadio = document.querySelector('input[name="radio-1"]:checked');
      if (checkedRadio) {
        const label = checkedRadio.closest(".radio-wrapper")?.querySelector("label");
        const locationEl = label?.querySelector(".bespoke_body20.button-content");
        if (locationEl) {
          const locationText = locationEl.innerHTML
            .replace(/<br\s*\/?>/gi, ", ")
            .replace(/\s+,/g, ",")
            .replace(/\s{2,}/g, " ")
            .trim();
          const locStrong = document.querySelector("p.bespoke_body20.detailed-location strong");
          if (locStrong) {
            while (locStrong.nextSibling) locStrong.parentNode.removeChild(locStrong.nextSibling);
            locStrong.after(" " + locationText);
          }
        }
      }

      // Update PURPOSE summary
      const titleElem = document.querySelector(".rolex-appointment-block-text.active .bespoke_body24.title");
      if (titleElem) {
        const titleText = titleElem.textContent.trim();
        const purposeStrong = document.querySelector("p.bespoke_body20.detailed-purpose strong");
        if (purposeStrong) {
          while (purposeStrong.nextSibling) purposeStrong.parentNode.removeChild(purposeStrong.nextSibling);
          purposeStrong.after(" " + titleText);
        }
      }

      // --- TRACKING STRING ---
      const serviceNameMapping = {
        "Rolex Watches": "collection discovery",
        "Rolex Servicing": "watch servicing",
        "Sell or Trade": "watch trading"
      };


      function convertTo24Hour(time12h) {
            const [time, modifier] = time12h.split(' ');
            let [hours, minutes] = time.split(':');
            
            if (hours === '12') {
                hours = '00';
            }
            
            if (modifier === 'PM') {
                hours = parseInt(hours, 10) + 12;
            }
            
            return `${String(hours).padStart(2, '0')}:${minutes}`;
        }

      const subtitleEl = document.querySelector(".rolex-appointment-block-text.active .bespoke_legend16.subtitle");
      const displayedServiceName = subtitleEl?.textContent.trim() || "N/A";
      const serviceName = serviceNameMapping[displayedServiceName] || displayedServiceName;

      const dTrack = dateValue ? new Date(dateValue) : new Date();
      const dayOfWeek = dTrack.toLocaleString("en-GB", { weekday: "long" });
      const formattedDate = dateValue || dTrack.toISOString().slice(0, 10);
      //const selectedTime = timeValue; // Morning/Evening exactly
      const selectedTime = convertTo24Hour(timeValue);

      window.appointmentInformation = `${serviceName}|${dayOfWeek}|${formattedDate}|${selectedTime}`;
      _satellite.track("bookAppointment");

      // Debug
      // console.log("appointmentInformation:", window.appointmentInformation);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {

  setTimeout(function () {

    // Observe clicks on dynamically generated Next buttons
    document.body.addEventListener("click", function (e) {
      const nextBtn = e.target.closest('button[data-action-next]');
      if (!nextBtn) return;

      // Wait a tiny bit so new step content renders before scroll
      setTimeout(function () {

        const formContainer = document.querySelector('.appointment-section, .rolex-appointment-section, .gfb__form');

        if (formContainer) {
          const isMobile = window.matchMedia("(max-width: 1025px)").matches;
          const offset = isMobile ? 70 : 100;
          const scrollY = window.pageYOffset || window.scrollY || 0;
          const top = formContainer.getBoundingClientRect().top + scrollY - offset;

          window.scrollTo({
            top: Math.max(0, top),
            behavior: "smooth"
          });
        }
      }, 400); // form re-render delay handle
    });

  }, 1500); // wait for Globo form load


const targetNode = document.querySelector(".rolex-appointment-form"); 

if (targetNode) {
    const autoScrollObserver = new MutationObserver((mutationsList, observer) => {
        const autoScrollEl = document.querySelector(".rolex-appointment-form.form-group-block");
        
        if (autoScrollEl) {
            const autoScrollIsMobile = window.matchMedia("(max-width: 1025px)").matches;
            const autoScrollOffset = autoScrollIsMobile ? 130 : 190;
            const autoScrollTop = autoScrollEl.getBoundingClientRect().top + window.scrollY - autoScrollOffset;
            window.scrollTo({ top: autoScrollTop, behavior: "smooth" });
            
        }
    });

    autoScrollObserver.observe(targetNode, {
        attributes: true,
        attributeFilter: ['class']
    });
}
});


